import React, { useState, useMemo, useEffect } from 'react';
import LaboratoryResultItemsList, {
	ILaboratoryResultListItem,
} from './LaboratoryResultItemsList';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
// @ts-ignore
import styles from './LaboratoryResultsListWrapper.module.scss';
import { joinClasses } from '../../../../Utils/className.util';
import LaboratoryResultChart from './LaboratoryResultChart';
import {
	LaboratoryResultItem,
	LaboratoryResultResult,
	useLaboratoryResultsQuery,
} from '../../../../graphql/graphql';
import { useAppContext } from '../../../../Services/AppContext';
import Loading from '../../../../Components/Loading';
import Text from '../../../../Components/Base/Text/Text';
import ScrollContainer from '../../../Base/Components/ScrollContainer';

interface Props {
	patientId: string;
	selectedItem?: LaboratoryResultResult;
}

const LaboratoryResultsListWrapper: React.FC<Props> = ({
	patientId,
	selectedItem,
}) => {
	const { workplaceId } = useAppContext();
	const [activeItems, setActiveItems] = useState<LaboratoryResultResult[]>([]);
	const [selectedRow, setSelectedRow] = useState<
		ILaboratoryResultListItem | undefined
	>(undefined);

	useEffect(() => {
		if (selectedItem) {
			setActiveItems([selectedItem]);
		}
	}, [selectedItem]);

	const { data, isLoading } = useLaboratoryResultsQuery({
		where: { userId: patientId, workplaceId },
	});

	const items: LaboratoryResultItem[] = useMemo(() => {
		let tempItems: LaboratoryResultItem[] = [];

		activeItems.forEach(item => {
			tempItems = [...tempItems, ...item.laboratoryResultItems];
		});

		return tempItems;
	}, [activeItems]);

	const handleSelectDate = (item: LaboratoryResultResult) => {
		const remove = activeItems.some(i => i.id === item.id);
		if (remove) {
			setActiveItems(activeItems.filter(i => i.id !== item.id));
		} else {
			setActiveItems([...activeItems, item]);
		}
	};

	const handleSelectRow = (row: ILaboratoryResultListItem) => {
		setSelectedRow(row);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.dateList}>
				<Text
					tx='component.laboratoryRequestListWrapper.collected'
					className={styles.title}
				/>
				{data?.laboratoryResults?.data?.map(item => {
					return (
						<div
							className={joinClasses([
								styles.date,
								activeItems.some(i => i.id === item.id)
									? styles.activeDate
									: '',
							])}
							onClick={() => handleSelectDate(item as LaboratoryResultResult)}>
							<FormattedMomentDate
								date={item.createdAt}
								format={DateFormat.DATE}
							/>
						</div>
					);
				})}
			</div>
			{items.length > 1 && (
				<div className={styles.itemsWrapper}>
					<div className={styles.tableWrapper}>
						<ScrollContainer>
							<LaboratoryResultItemsList
								items={items as ILaboratoryResultListItem[]}
								onRowClick={handleSelectRow}
							/>
						</ScrollContainer>
					</div>
					{selectedRow && (
						<LaboratoryResultChart
							selectedItem={selectedRow}
							items={items as ILaboratoryResultListItem[]}
						/>
					)}
				</div>
			)}
		</div>
	);
};

export default LaboratoryResultsListWrapper;
